function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import renderTemplateImpl from '../renderTemplate';
import VideoAdPlaybackManagerImpl from './VideoAdPlaybackManager';
import VideoAdTrackerImpl from './VideoAdTracker';
import VideoAdFullscreenManagerImpl from './VideoAdFullscreenManager';
import VideoAdSeekingManagerImpl from './VideoAdSeekingManager';
import { videoTemplate as videoTemplateImpl } from './videoTemplate';
import { track } from '../../../tracking';
import { withAdClickedEvent } from '../../../tracking/events';

var VideoAdComponent = /*#__PURE__*/function () {
  function VideoAdComponent(shouldTrackEvent) {
    var renderTemplate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : renderTemplateImpl;
    var videoTemplate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : videoTemplateImpl;
    var VideoAdPlaybackManager = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : VideoAdPlaybackManagerImpl;
    var VideoAdTracker = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : VideoAdTrackerImpl;
    var VideoAdFullscreenManager = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : VideoAdFullscreenManagerImpl;
    var VideoAdSeekingManager = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : VideoAdSeekingManagerImpl;

    _classCallCheck(this, VideoAdComponent);

    this.shouldTrackEvent = shouldTrackEvent;
    this.renderTemplate = renderTemplate;
    this.videoTemplate = videoTemplate;
    this.VideoAdPlaybackManager = VideoAdPlaybackManager;
    this.VideoAdTracker = VideoAdTracker;
    this.VideoAdFullscreenManager = VideoAdFullscreenManager;
    this.VideoAdSeekingManager = VideoAdSeekingManager;
  }

  _createClass(VideoAdComponent, [{
    key: "processJson",
    value: function processJson(json) {
      var actionTypeKey = "actionType".concat(json.actiontype.substring(0, 1).toUpperCase()).concat(json.actiontype.substring(1));
      return _objectSpread(_objectSpread({}, json), {}, _defineProperty({}, actionTypeKey, true));
    }
  }, {
    key: "addAdClickEventListener",
    value: function addAdClickEventListener(renderTarget, adSpot) {
      var _this = this;

      var brandClickElement = renderTarget.getElementsByClassName('native-video__brand')[0];
      var textClickElement = renderTarget.getElementsByClassName('native-video__text')[0];
      var ctaElements = renderTarget.querySelectorAll('.native-video__cta a')[0];
      var clickElements = [brandClickElement, textClickElement, ctaElements];
      clickElements.forEach(function (element) {
        return element && element.addEventListener('click', function () {
          return track(withAdClickedEvent(), adSpot, _this.shouldTrackEvent);
        });
      });
    }
  }, {
    key: "addTermsClickEventListeners",
    value: function addTermsClickEventListeners(renderTarget) {
      var termsOpenButton = renderTarget.getElementsByClassName('native-video__terms-open-button')[0];
      var termsCloseButton = renderTarget.getElementsByClassName('native-video__terms-close-button')[0];
      var overLay = renderTarget.getElementsByClassName('native-video__card-overlay')[0];

      if (!termsOpenButton || !termsCloseButton || !overLay) {
        return;
      }

      termsOpenButton.addEventListener('click', function () {
        return overLay.classList.add('show');
      });
      termsCloseButton.addEventListener('click', function () {
        return overLay.classList.remove('show');
      });
    }
  }, {
    key: "render",
    value: function render(json, renderTarget, adSpot) {
      var _this2 = this;

      var processedJson = this.processJson(json);
      return this.renderTemplate(renderTarget, processedJson, this.videoTemplate).then(function () {
        _this2.initVideo(renderTarget, processedJson);

        _this2.addAdClickEventListener(renderTarget, adSpot);

        _this2.addTermsClickEventListeners(renderTarget);
      });
    }
  }, {
    key: "initVideo",
    value: function initVideo(renderTarget, json) {
      var playButton = renderTarget.getElementsByClassName('native-video__play')[0];
      var soundControl = renderTarget.getElementsByClassName('native-video__sound-control')[0];
      var posterImage = renderTarget.getElementsByClassName('native-video__image')[0];
      var video = renderTarget.getElementsByTagName('video')[0];
      var videoContainer = renderTarget.getElementsByClassName('native-video__element-container')[0];
      var logo = renderTarget.getElementsByClassName('native-video__brand')[0];
      video.controls = false;
      this.VideoAdPlaybackManager(video, videoContainer, playButton, soundControl, posterImage);
      this.VideoAdTracker(video, soundControl, playButton, logo, json.trackers);
      this.VideoAdFullscreenManager(video, videoContainer, playButton, posterImage);
      this.VideoAdSeekingManager(video);
    }
  }]);

  return VideoAdComponent;
}();

export default VideoAdComponent;
//# sourceMappingURL=VideoAdComponent.js.map